import drLogo from "../assets/images/dr_logo.svg";
import aseLogo from "../assets/images/logo-ase.svg";

const images = {
  logo: aseLogo,
  drLogo: drLogo,
};

export default images;
